import React from 'react'

export class MessageComponent extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      opened: true,
      style: this.initialize(props)

    }

    this.close = this.close.bind(this)
  }

  initialize(prms) {
    let s = {
      width: 400,
      height: 100
    }

    if(prms.width) {
      s.width = parseInt(prms.width)
    }
    if(prms.height) {
      s.height = parseInt(prms.height)
    }

    s.marginLeft = -s.width / 2
    s.marginTop = -s.height / 2

    return s
  }

  close(e) {
    if(e)
      e.preventDefault()

    this.setState({
      opened: false
    })
    if(this.timeout) {
      clearTimeout(this.timeout)
    }
    if(this.props.onClose)
      this.props.onClose()

  }

  componentWillMount() {
    if(this.props.params.timeout) {
      this.timeout = setTimeout(()=> {
        this.close()
      }, 1000 * this.props.params.timeout)
    }
  }

  render() {
    if(!this.state.opened)
      return null
    return (
      <div className="dialog">
        <div className="dialog__bg" onClick={this.close}></div>
        <div className="dialog__content" style={this.state.style}>
          <div className="dialog__close" onClick={this.close}></div>
          <div className="dialog__message">{this.props.params.message}</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/shared/dialog/message.component.jsx